import { Action } from '../action/action.class'

/**
 * @file Defines the {@link Setting} class
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /** Class for handling a specific setting */
 export class Setting {

    /**
     * ID of setting to access localStorage
     * @memberof Setting
     * @private
     * @instance
     * @type {string}
     */
    _id

    /**
     * Label of setting to be displayed within UI
     * @memberof Setting
     * @private
     * @instance
     * @type {string}
     */
    _label

    /**
     * Orientation change event handler
     * @memberof Setting
     * @protected
     * @instance
     * @type {Action}
     */
    _onChange

    /**
     * Page setting is located in
     * @memberof Setting
     * @protected
     * @instance
     * @type {string}
     */
    _page

    /**
     * Default value of setting if not in localStorage
     * @memberof Setting
     * @private
     * @instance
     * @type {*}
     */
    _value
    
    /**
     * Initialise setting
     * @param {string} id_     - Setting ID.
     * @param {string} label_  - Setting label.
     * @param {string} page_   - ID of setting page in iron dog framework.
     * @param {*} value_       - Initial value of setting.
     */
    constructor(id_, label_, page_, value_) {

        this.id         = id_          //Store ID
        this.label      = label_       //Store label
        this.page       = page_        //Store setting page
        this.value      = value_       //Store initial value
        this._onChange  = new Action() //Initialize onChange custom event

    }

    /** Get onChange */ get onChange() { return this._onChange }
    
    /** Get id */ get id()   { return this._id }
    /** Set id */ set id(v_) { this._id = v_ }

    /** Get label */ get label()   { return this._label }
    /** Set label */ set label(v_) { this._label = v_ }

    /** Get page */ get page()   { return this._page }
    /** Set page */ set page(v_) { this._page = v_ }

    /** Get value */ get value()   { return this._value }
    /** Set value */ set value(v_) { return this._value = v_ }

 }